import React from "react";
import _ from "lodash";
import dayjs from "dayjs";
import { compareYield } from "./harvestOptimiser.utils.js";

export function reducer(state, action) {
  switch (action.type) {
    case "INITIALIZE": {
      const { currentHarvestPlan, recommendedHarvestPlan } = action.payload;

      const sortedPlan = [...currentHarvestPlan].sort((a, b) =>
        dayjs(a.harvest_pass_day_1_date).isAfter(dayjs(b.harvest_pass_day_1_date)) ? 1 : -1,
      );

      return {
        currentHarvestPlan: sortedPlan,
        recommendedHarvestPlan: structuredClone(recommendedHarvestPlan),
      };
    }

    case "updateHarvestDay": {
      const { rowId, pass, block, selectedHarvestDate, lookupTable } = action.payload;

      const currentHarvestPlan = state.currentHarvestPlan;
      const recommendedHarvestPlan = state.recommendedHarvestPlan;

      // get the changed row from currentHarvestPlan using rowId
      const row = currentHarvestPlan.find((r) => r.id === rowId);
      const rowIndex = currentHarvestPlan.findIndex((r) => r.id === rowId);

      const recommendedRow = recommendedHarvestPlan.find(
        (plan) => plan.block === block && plan.paddock === row.paddock,
      );

      const recommendedYield =
        pass === "First Pass"
          ? recommendedRow?.harvest_pass_day_1_yield
          : recommendedRow?.harvest_pass_day_2_yield;

      let notes = "";

      const pass1Filter = {
        block,
        paddock: row.paddock,
        harvest_pass_day_1_date: selectedHarvestDate,
        harvest_pass_day_2_date: row["harvest_pass_day_2_date"],
      };

      const pass2Filter = {
        block,
        paddock: row.paddock,
        harvest_pass_day_1_date: row["harvest_pass_day_1_date"],
        harvest_pass_day_2_date: selectedHarvestDate,
      };

      const filterCriteria = pass === "First Pass" ? pass1Filter : pass2Filter;

      const lookupRow = _.find(lookupTable, filterCriteria);

      const newYield =
        pass === "First Pass"
          ? lookupRow?.harvest_pass_day_1_yield
          : lookupRow?.harvest_pass_day_2_yield;

      if (pass === "First Pass") {
        if (!dayjs(selectedHarvestDate).isSame(row["harvest_pass_day_2_date"])) {
          notes = compareYield(recommendedYield, newYield);
        }
      } else {
        if (!dayjs(selectedHarvestDate).isSame(row["harvest_pass_day_1_date"])) {
          notes = compareYield(recommendedYield, newYield);
        }
      }

      const newHarvestPlan = [...currentHarvestPlan];
      newHarvestPlan[rowIndex] = {
        ...newHarvestPlan[rowIndex],
        ...(pass === "First Pass"
          ? { harvest_pass_day_1_date: selectedHarvestDate }
          : { harvest_pass_day_2_date: selectedHarvestDate }),
        ...lookupRow,
        notes,
      };

      const newState = {
        ...state,
        currentHarvestPlan: [...newHarvestPlan],
        recommendedHarvestPlan,
      };

      return newState;
    }

    default:
      return state;
  }
}